import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { TiThMenu } from "react-icons/ti";

export default function NavbarLight() {
  const [navbarOpen, setNavbarOpen] = useState(false);

  useEffect(() => {
    // Lock scroll when menu is open
    document.body.style.overflow = navbarOpen ? "hidden" : "auto";
  }, [navbarOpen]);

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/blog", label: "Blog" },
    { path: "/what-i-have-been-building", label: "What I've Been Building" },
    { path: "/about", label: "About" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <nav className="lg:hidden z-50 relative font-sans text-purple-800">
      <button
        onClick={() => setNavbarOpen(true)}
        className="text-2xl p-2 focus:outline-none"
        aria-label="Open Menu"
      >
        <TiThMenu />
      </button>

      {/* Fullscreen Overlay */}
      {navbarOpen && (
        <div className="fixed inset-0 bg-slate-900/95 text-white z-50 flex flex-col items-center justify-center transition duration-300">
          {/* Close button */}
          <button
            onClick={() => setNavbarOpen(false)}
            className="absolute top-6 right-6 text-3xl text-purple-400 hover:text-purple-200"
            aria-label="Close Menu"
          >
            <MdClose />
          </button>

          {/* Nav items */}
          <ul className="space-y-8 text-xl font-medium text-center">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  onClick={() => setNavbarOpen(false)}
                  className="hover:text-purple-400 transition-colors"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
}
